import {
  CompanyTagUnionType,
  mapCompanyTagType,
  useFindCompanyTagsSuspense,
} from '@api';
import {
  AddCompanyFormSchemaType,
  AddCompanyModal,
  useCreateCompany,
} from '@common';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';

export const AddCompany: React.FC = () => {
  const { t } = useTranslation('companies');
  const [opened, { open, close }] = useDisclosure(false);
  const { data: companyTags } = useFindCompanyTagsSuspense({
    query: {
      select: (data) => data.data.map(mapCompanyTagType),
    },
  });
  const { submitNewCompany } = useCreateCompany();

  const handleSubmit = async (
    data: AddCompanyFormSchemaType
  ): Promise<void> => {
    await submitNewCompany({
      ...data,
      categories: data.categories as CompanyTagUnionType[],
      address: {
        ...data.address,
        cityEnglish: null,
        state: null,
      },
      contact: {
        ...data.contact,
        mobile: null,
      },
    });
  };

  return (
    <>
      <Button
        size="xs"
        color="blue"
        onClick={open}
        aria-label={t('ADD_COMPANY.BUTTON_LABEL')}
      >
        <FontAwesomeIcon icon={faPlus} />
      </Button>
      <AddCompanyModal
        companyTags={companyTags}
        opened={opened}
        onClose={close}
        onSubmit={handleSubmit}
      />
    </>
  );
};
